<template>
    <div class="shuju" style="background: #F6F8FB;">
      <!-- <div class="" v-if="expireStatus==2">
        <div class="shuju_tips color_f flex bor_rad5">
          <div class="mar_r20">温馨提示：店铺即将到期，到期后店铺仍可访问，但店铺功能不可使用，建议尽快联系您的商务经理进行续费！</div>
        </div>
      </div> -->
      <div class="body flex-bet flex-y-top">
        <div class="flex-g-1">
          <div class="flex bor_rad5">
            <div class="flex-g-0 t_l wid30 color_1d fon_16 wei ba_f pad_15 bor_rad5" style="height: 105px">
              <div class="mar_t10">
                <span>{{ greet() }} !</span>
                管理员</div>
              <div class="mar_t10"> 欢迎登入后台管理系统</div>
            </div>
            <div class="flex-g-1 t_l wid70 ba_f mar_l20 pad_15 bor_rad5" style="height: 105px">
              <div class="shuju_title">
                <div class="shuju_title_text">
                  <span>待办事项</span>
                </div>
              </div>
              <div class="flex mar_t10">
                
                <div class="flex-g-1 flex pad_l_20">
                  <div>
                    <span class="iconfont iconshanghu fon_14 mar_r5"></span>
                    <span class="fon_14 color_9">产品待审核：</span>
                  </div>
                  <div class="maincolor fon_14 marb_l15 wei">{{ dddata.producrCount || 0}}

                    <a style="color: #409EFF;margin-left: 10px;" @click="jump('/plus/hproduct/index/index?status=1')">前往</a>
                  </div>
                </div>
                
                <div class="flex-g-1 flex pad_l_20">
                  <div>
                    <span class="iconfont iconshanghu fon_14 mar_r5"></span>
                    <span class="fon_14 color_9">门店申请待审核：</span>
                  </div>
                  <div class="maincolor fon_14 marb_l15 wei">{{ dddata.peedCount || 0}} 

                    <a style="color: #409EFF;margin-left: 10px;" @click="jump('/store/index?type=sauth')">前往</a>
                  </div>
                </div>
                <div class="flex-g-1 flex pad_l_20">
                  <div>
                    <span class="iconfont iconshanghu fon_14 mar_r5"></span>
                    <span class="fon_14 color_9">提现待处理：</span>
                  </div>
                  <div class="maincolor fon_14 marb_l15 wei">{{ dddata.cashCount || 0}}

                    <a style="color: #409EFF;margin-left: 10px;" @click="jump('/plus/agent/index?type=cash')">前往</a>
                  </div>
                </div>
                <div class="flex-g-1 flex pad_l_20">
                  <div>
                    <span class="iconfont iconshanghu fon_14 mar_r5"></span>
                    <span class="fon_14 color_9">新增订单：</span>
                  </div>
                  <div class="maincolor fon_14 marb_l15 wei">{{ dddata.newOrderCount || 0}}

                    <a style="color: #409EFF;margin-left: 10px;" @click="jump('/plus/horder/index/index', {status: 1})">前往</a>
                  </div>
                </div>

                <div class="flex-g-1 flex pad_l_20">
                  <div>
                    <span class="iconfont iconshanghu fon_14 mar_r5"></span>
                    <span class="fon_14 color_9">超时订单：</span>
                  </div>
                  <div class="maincolor fon_14 marb_l15 wei">{{ dddata.timeoutOrderCount || 0}}

                    <a style="color: #409EFF;margin-left: 10px;" @click="jump('/plus/horder/index/index', {status: 2})">前往</a>
                  </div>
                </div>


             
              </div>
            </div>
          </div>
          <div class="ba_f bor_rad5 mar_t20">
            <div class="tit flex pad_10">
              <div class="shuju_title">
                <div class="shuju_title_text">
                  <span>实时概况</span>
                  <span class="fnormal fon_14 color_9 mar_l10">更新时间：{{ dateFormat(date) }}</span>
                </div>
              </div>
   
            </div>
          <!-- 实时概况部分 -->
<div class="tongji_con flex pad_tb_20">
  <!-- 用户(个) -->
  <div class="flex-g-1 pad_l_30">
    <div class="flex">
      <div class="title6 mar_l20">用户(个)</div>
    </div>
    <div class="fon_30 title35 mar_t10 wei mar_l20">{{ lldata.today.user || 0 }}</div>
    <div class="fon_12 title6 lh25 mar_t10 mar_l20" v-if="lldata.yesterday">昨日：{{ lldata.yesterday.user || 0 }}</div>
  </div>

  <!-- 门店/广告公司(个) -->
  <div class="flex-g-1 pad_l_30">
    <div class="flex">
      <div class="title6 mar_l20">门店/广告公司(个)</div>
    </div>
    <div class="fon_30 title35 mar_t10 wei mar_l20">{{ lldata.today.store || 0 }}</div>
    <div class="fon_12 title6 lh25 mar_t10 mar_l20" v-if="lldata.yesterday">昨日：{{ lldata.yesterday.store || 0 }}</div>
  </div>

  <!-- 安装师傅/设计(个) -->
  <div class="flex-g-1 pad_l_30">
    <div class="flex">
      <div class="title6 mar_l20">安装师傅/设计(个)</div>
    </div>
    <div class="fon_30 title35 mar_t10 wei mar_l20">{{ lldata.today.master || 0 }}</div>
    <div class="fon_12 title6 lh25 mar_t10 mar_l20" v-if="lldata.yesterday">昨日：{{ lldata.yesterday.master || 0 }}</div>
  </div>

  <!-- 自由职业人员(个) -->
  <div class="flex-g-1 pad_l_30">
    <div class="flex">
      <div class="title6 mar_l20">自由职业人员(个)</div>
    </div>
    <div class="fon_30 title35 mar_t10 wei mar_l20">{{ lldata.today.driver || 0 }}</div>
    <div class="fon_12 title6 lh25 mar_t10 mar_l20" v-if="lldata.yesterday">昨日：{{ lldata.yesterday.driver || 0 }}</div>
  </div>
</div>
          </div>
        </div>
      </div>




      <!-- 系统概览数据 -->
  <div class="grid grid-cols-5 gap-6 mb-6" v-if="obj" style="margin-top: 10px;margin-left: 10px;margin-right: 10px;">

          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col" >
            <div class="flex items-center text-gray-600 mb-4">
              <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
              <span>总额（全部订单）</span>
            </div>
              <div class="text-3xl font-medium" style="color:crimson;">{{ obj.statis_all.total }}</div>
          </div>



          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col" >
            <div class="flex items-center text-gray-600 mb-4">
              <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
              <span>总额(已完成订单)</span>
            </div>
              <div class="text-3xl font-medium" style="color:#7181fc;">{{ obj.statis_all_ywc.total }}</div>
          </div>

          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col" >
            <div class="flex items-center text-gray-600 mb-4">
              <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
              <span>总额(待完成订单)</span>
            </div>
              <div class="text-3xl font-medium" style="color:#b7fc71;">{{ obj.statis_all_dwc.total }}</div>
          </div>

          

          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col" >
            <div class="flex items-center text-gray-600 mb-4">
              <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
              <span>总额(生产中订单)</span>
            </div>
              <div class="text-3xl font-medium" style="color:#49f8ff;">{{ obj.statis_all_sc.total }}</div>
          </div>


          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col" >
            <div class="flex items-center text-gray-600 mb-4">
              <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
              <span>总额(已发货订单)</span>
            </div>
              <div class="text-3xl font-medium" style="color:#ed4040;">{{ obj.statis_all_yfh.total }}</div>
          </div>


          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col" >
            <div class="flex items-center text-gray-600 mb-4">
              <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
              <span>总额(待付款订单)</span>
            </div>
              <div class="text-3xl font-medium" style="color:#7799ff;">{{ obj.statis_all_dfk.total }}</div>
          </div>


          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col" >
            <div class="flex items-center text-gray-600 mb-4">
              <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
              <span>总额(已付款订单)</span>
            </div>
              <div class="text-3xl font-medium" style="color:#ff832b;">{{ obj.statis_all_yfk.total }}</div>
          </div>


          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col" >
            <div class="flex items-center text-gray-600 mb-4">
              <i class="fas fa-user text-blue-500 text-xl mr-2"></i>
              <span>总额(已取消订单)</span>
            </div>
              <div class="text-3xl font-medium" style="color:#5cff38;">{{ obj.statis_all_yqx.total }}</div>
          </div>



          <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
     	<div class="flex items-center text-gray-600 mb-4">
     		<i class="fas fa-user text-blue-500 text-xl mr-2"></i>
     		<span>今日（全部订单）</span>
     	</div>
     	<div class="text-3xl font-medium" style="color:crimson;">{{ obj.statis_today.total }}</div>
     </div>



     <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
     	<div class="flex items-center text-gray-600 mb-4">
     		<i class="fas fa-user text-blue-500 text-xl mr-2"></i>
     		<span>今日(已完成订单)</span>
     	</div>
     	<div class="text-3xl font-medium" style="color:#7181fc;">{{ obj.statis_today_ywc.total }}</div>
     </div>

     <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
     	<div class="flex items-center text-gray-600 mb-4">
     		<i class="fas fa-user text-blue-500 text-xl mr-2"></i>
     		<span>今日(待完成订单)</span>
     	</div>
     	<div class="text-3xl font-medium" style="color:#b7fc71;">{{ obj.statis_today_dwc.total }}</div>
     </div>



     <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
     	<div class="flex items-center text-gray-600 mb-4">
     		<i class="fas fa-user text-blue-500 text-xl mr-2"></i>
     		<span>今日(生产中订单)</span>
     	</div>
     	<div class="text-3xl font-medium" style="color:#49f8ff;">{{ obj.statis_today_sc.total }}</div>
     </div>


     <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
     	<div class="flex items-center text-gray-600 mb-4">
     		<i class="fas fa-user text-blue-500 text-xl mr-2"></i>
     		<span>今日(已发货订单)</span>
     	</div>
     	<div class="text-3xl font-medium" style="color:#ed4040;">{{ obj.statis_today_yfh.total }}</div>
     </div>


     <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
     	<div class="flex items-center text-gray-600 mb-4">
     		<i class="fas fa-user text-blue-500 text-xl mr-2"></i>
     		<span>今日(待付款订单)</span>
     	</div>
     	<div class="text-3xl font-medium" style="color:#7799ff;">{{ obj.statis_today_dfk.total }}</div>
     </div>


     <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
     	<div class="flex items-center text-gray-600 mb-4">
     		<i class="fas fa-user text-blue-500 text-xl mr-2"></i>
     		<span>今日(已付款订单)</span>
     	</div>
     	<div class="text-3xl font-medium" style="color:#ff832b;">{{ obj.statis_today_yfk.total }}</div>
     </div>


     <div class="bg-white rounded-lg shadow-sm p-6 flex flex-col">
     	<div class="flex items-center text-gray-600 mb-4">
     		<i class="fas fa-user text-blue-500 text-xl mr-2"></i>
     		<span>今日(已取消订单)</span>
     	</div>
     	<div class="text-3xl font-medium" style="color:#5cff38;">{{ obj.statis_today_yqx.total }}</div>
     </div>


</div>


      <div class="mar_t20 ba_f outmain pad_20 ">
        <div class="shuju_title">
          <div class="shuju_title_text">
            <span>流量看板</span>
          </div>
        </div>
        <div class="flex-bet">
          <div class="bflex-7 outmain">
    
            <div id="mainEch" style="height: 400px;"></div>
          </div>
          <div class="bflex-3 mar_l20">
            <div class="flex-bet pad_20 flex-y-top">
              <div >
                <p class="title6 fon_14">今日浏览量(pv)</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei" >{{ lldata.today.pv?lldata.today.pv:0 }}</p>
                <div class="flex">
                  <p class="fon_12 title6 lh25">昨日： {{ lldata.yesterday.pv?lldata.yesterday.pv:0 }}</p>

                </div>
              </div>
     
            </div>
            <div class="flex-bet pad_20 flex-y-top mar_t20">
              <div >
                <p class="title6 fon_14">今日访客数(uv)</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ lldata.today.uv?lldata.today.uv:0 }}</p>
                <div class="flex">
                  <p class="fon_12 title6 lh25">昨日： {{ lldata.yesterday.uv? lldata.yesterday.uv:0 }}</p>
                
                </div>
              </div>
 
            </div>
          </div>
        </div>
      </div>
    
    
    </div>
  </template>
  <script>
  import echarts from 'echarts'
  import IndexApi from "@/api/index.js";
  export default {
    components: {},
    mounted() {
 
      this.init();
    },
    data() {
      return {
        notice: {},
        infoList: [],//资讯列表
        shopData: {
          receiveStatus: '2',
        },//包含门店Logo 门店名称 营业状态 自动接单
        shopInfoArr: {},//包含门店状态，时间
        timeArr: [],//时间段
        ssdata: {},//实时概况
        dddata: {},//订单概况
        lldata: {},//流量看板
        goodsData: [],
        orderData: [],
        echarts1_option: {
          color: ['#4284ED', '#42CCF0'],
          tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              var time = '';
              for (var i = 0; i < params.length; i++) {
                var numbers = '</br>' + params[i].seriesName + '：' + params[i].value;
                time += numbers
              }
              return time
            }
          },
          legend: {
            data: ['浏览量', '访客数']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            // 去除坐标轴上的刻度线
            axisTick: {
              show: false,
              lineStyle: {
                color: '#ccc',
                type: 'dashed'
              }
            },
            // x轴的字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: '#333',
                fontSize: '12'
              }
            },
            // x轴的颜色和宽度
            axisLine: {
              lineStyle: {
                color: '#f7f7f7',
                width: 2,   //这里是坐标轴的宽度,可以去掉
              }
            },
            data: []
          },
          yAxis: {
            type: 'value',
            axisTick: {       //y轴刻度线
              "show": false
            },
            axisLine: {
              "show": false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#333',
                fontSize: '12'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dotted',
                color: '#DDDDDD',
              },
              show: true
            }
          },
          series: [
            {
              name: '浏览量',
              type: 'line',
              stack: '总量',
              smooth: true,
              data: []
            },
            {
              name: '访客数',
              type: 'line',
              stack: '总量',
              smooth: true,
              data: []
            }
          ]
        },
        echarts1_option3: {
          color: ['#1890FF', '#2FC25B'],
          tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              var time = '时间：' + (Number(params[0].name) - 1) + ':00' + '~' + Number(params[0].name) + ':00';
              for (var i = 0; i < params.length; i++) {
                var numbers = '</br>' + params[i].seriesName + '：' + params[i].value;
                time += numbers
              }
              return time
            }
          },
          legend: {
            data: ['今日营业额'],
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            // 去除坐标轴上的刻度线
            axisTick: {
              show: false,
              lineStyle: {
                color: '#ccc',
                type: 'dashed'
              }
            },
            // x轴的字体样式
            axisLabel: {
              show: true,
              textStyle: {
                color: '#333',
                fontSize: '12'
              }
            },
            // x轴的颜色和宽度
            axisLine: {
              lineStyle: {
                color: '#F7F7F7',
                width: 2,   //这里是坐标轴的宽度,可以去掉
              }
            },
            data: []
          },
          yAxis: {
            type: 'value',
            axisTick: {       //y轴刻度线
              "show": false
            },
            axisLine: {
              "show": false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#333',
                fontSize: '12'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dotted',
                color: '#DDDDDD',
              },
              show: true
            }
          },
          series: [
            {
              name: '今日营业额',
              type: 'line',
              stack: '总量',
              smooth: true,
              data: []
            },
            // {
            //   name: '昨日营业额',
            //   type: 'line',
            //   stack: '总量',
            //   smooth: true,
            //   data: []
            // }
          ]
        },

        date: new Date(),
        expireStatus:'',
        obj:{

        }
      }
    },
    methods: {
                /*获取数据*/
    getData() {
      let self = this;
   
        IndexApi.getCountx(this.form)
          .then((data) => {
            self.loading = false;
            self.obj = data.data;
          })
          .catch((error) => {});
        IndexApi.dashboardStats().then((res)=>{
          self.dddata = res.data
          console.log(self.dddata);
          
        })

    },
        
      // jump(url){
      //   this.$router.push(url);
      // },

      jump(path, query = {}) {
        this.$router.push({
          path: path,
          query: query
        });
      },
  
      init() {
        this.getData();
        this.getIndex();


      },
      getIndex(){
        let self = this;
      IndexApi.getCounts({})
        .then((data) => {
          console.log(data);
          self.loading = false;


        //流量看板----
        self.lldata = data.data.daily
        this.echarts1_option.series[0].data = data.data.dailys.chart.series['今日浏览量'];
        this.echarts1_option.series[1].data = data.data.dailys.chart.series['今日访客数'];
        this.echarts1_option.xAxis.data = data.data.dailys.chart.xAxis
        console.log(' this.echarts1_option', this.echarts1_option)
        let myChart = echarts.init(document.getElementById('mainEch'))
        myChart.setOption(this.echarts1_option, true)
      
        })
        .catch((error) => {});
      },
  
      jrgk() {
        let myChart = echarts.init(document.getElementById('mainEch3'))
        myChart.setOption(this.echarts1_option3, true)
      },
  
      async changeSwitch(row, type) {
        const {msg} = await changeShopStatus({storeOpen: row, type,});
        this.$baseMessage(msg, "success");
        this.init();
      },
      async changeSwitch2(row, type) {
        const {msg} = await changeShopStatus({receiveStatus: row, type});
        this.$baseMessage(msg, "success");
        this.init();
      },
      handleEdit(row) {
        if (row) {
          this.$refs["edit"].showEdit(row);
        }
      },
      mainEch32(){
        let myChart = echarts.init(document.getElementById('mainEch32'))
        myChart.setOption(this.echarts3_option, true)
      },
      mainEch42(){
        let myChart = echarts.init(document.getElementById('mainEch42'))
        myChart.setOption(this.echarts4_option, true)
      },
      greet(){
        var content=''
        var date=new Date()
        var hours=date.getHours()
        if(hours>=6&&hours<12){
          content='上午好'
        }else if(hours>=12&&hours<18){
          content='下午好'
        }else{
          content='晚上好'
        }
        return content
      },
      dateFormat(time) {
        var date = new Date(time);
        var year = date.getFullYear();
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      },
    }
  }
  </script>
  <style lang="scss" scoped>
 
  .shuju {
    font-family: PingFangSC, "Microsoft Yahei", Helvetica, Tahoma, Arial, "Hiragino Sans GB", "Hiragino Sans GB W3", STXihei, STHeiti, Heiti, SimSun, sans-serif !important;
  }
  
  .bblue {
    background: linear-gradient(45deg, #1d42ab, #57a3f3);
  }
  
  .colorTiao {
    width: 6px;
    height: 22px;
  }
  
  .tiao1 {
    background: #5C7CEB;
  }
  
  .tiao2 {
    background: #FCAB40;
  }
  
  .tiao3 {
    background: #49CBD3;
  }
  
  .title6 {
    //color: #666;
    color: #999;
    font-size: 14px;
  }
  
  .title35 {
    color: #353535;
  }
  
  .bortColor {
    border: 1px solid #eee;
  }
  .borderBG{
    background: #F4F4F4;
    border-radius: 5px;
  }
  
  .bortColor1 {
    border-top: 4px solid #1890FF;
  }
  
  .bortColor2 {
    border-top: 4px solid #2FC25B;
  }
  
  .bortColor3 {
    border-top: 4px solid #FCDB69;
  }
  
  .bortColor4 {
    border-top: 4px solid #F4667C;
  }
  
  .bortColor5 {
    border-top: 4px solid #EBA675;
  }
  
  .bortColor6 {
    border-top: 4px solid #FE840C;
  }
  
  .toolTip .el-button--text {
    color: #B9B9CC;
  }
  
  .shuju_title {
    position: relative;
    padding: 10px;
    width: 100%;
    min-height: 40px;
    //background-color: #f8f8f8;
  }
  
  .shuju_title .shuju_title_text {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    padding-left: 9px;
    font-size: 16px;
    color: #353535;
    line-height: 20px;
  }
  
  .shuju_title .shuju_title_text::before {
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
    margin-right: 5px;
    content: '';
    display: inline-block;
    height: 14px;
    width: 3px;
    background-color: #2A75ED;
  }
  
  .shuju_tips {
    background-color: #EE4141;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 20px;
    width: 100%;
    height: 56px;
  }
  
  .bafd {
    background: #fff5ed;
  }
  
  .namelogo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  
  .lhh24 {
    height: 24px;
    line-height: 24px;
  }
  
  
  </style>
  <style>
  .el-badge__content {
    right: 1px !important;
    height: 22px;
    line-height: 20px;
  }
  .yc{opacity: 0}
  </style>
  


// WEBPACK FOOTER //
// src/views/home/home.vue